import React from "react";
import { Box, makeStyles, MenuItem, TextField } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        height:50,
        margin:5,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box:{
        margin:0,
    }
}))

export default function Index({ state, handleChange }) {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                width="100%"
                height="50px"
            >
                <TextField
                    id="standard-select-currency"
                    select
                    value={state?.currency_id ? state?.currency_id : ''}
                    onChange={(event) => handleChange(+event.target.value, "currency_id")}
                    helperText=""
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={'نوع معامله'}
                >

                    <MenuItem value="1"> فیزیکی </MenuItem>
                    <MenuItem value="2"> صادراتی </MenuItem>
               
                    {/* <MenuItem value="3"> فرعی </MenuItem> */}
                </TextField>
            </Box>
        </div>)
}
